/* eslint-disable spaced-comment */
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  OnChanges,
} from '@angular/core';

import { ModalComponent } from '@cigna/shared/angular/ui-v3/modal-ui';
import { Subject } from 'rxjs';
import moment from 'moment';
import { Router } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  PostAffirmRequestPayload,
  Agency,
  AppFacade,
} from '@cigna/cigna-for-brokers/shared/data-access';
import {
  ServiceError,
  getAdobeSiteSection,
} from '@cigna/cigna-for-brokers/shared/util';
/* eslint-disable @nx/enforce-module-boundaries */
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { MatDialog } from '@angular/material/dialog';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';

@Component({
  selector: 'cigna-legal-affirmation-modal',
  templateUrl: './legal-affirmation-modal.component.html',
  styleUrls: ['./legal-affirmation-modal.component.scss'],
})
export class LegalAffirmationModalComponent implements OnInit, OnChanges {
  @Output() submitLegalAffirm = new EventEmitter<PostAffirmRequestPayload>();
  @Input() agencyList: Agency[];
  @Input() isBackLink: boolean;
  @Input() isViewStatmtLink: boolean;
  @Input() detailsError: ServiceError;
  @Input() isLoadingAppShared: boolean;
  @Input() isPostAffirmFailed: boolean;
  @Input() isGetAgencyFailed: boolean;
  @Input() affirmResponse: string;
  @Input() isImpersonatorFlag: boolean | undefined;
  @Input() agencyListError: ServiceError | undefined;
  firstName$ = this.appstateFacade.firstName$;

  @ViewChild('legalAffirmationModal', { static: true })
  modal: ModalComponent;

  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    public _appFacade: AppFacade,
    private appstateFacade: AppstateFacade,
    private router: Router,
    public dialog: MatDialog,
    private analytics: ShellTrackHandlers,
  ) {}
  dWidth = '60rem';

  ngOnInit(): void {}
  ngOnChanges(_changes?: SimpleChanges): void {
    if (
      _changes?.affirmResponse?.currentValue &&
      _changes.affirmResponse.currentValue === 'success' &&
      _changes.affirmResponse.previousValue === ''
    ) {
      if (this.isBackLink || this.isViewStatmtLink) {
        this.router.navigate(['/secure/commercial/compensation/']);
      }
      this.modal.close();
      this.appstateFacade.setLegalAffirmStatus(false);
    }
  }
  openContactUsModal() {
    if (this.isImpersonatorFlag) {
      this.dWidth = '40rem';
    }

    const contactUsModal = this.dialog.open(ContactUsComponent, {
      width: this.dWidth,
      autoFocus: false,
      disableClose: true,
    });
    contactUsModal.afterClosed().subscribe((response) => {
      if (response.closeLegalAffirm) {
        this.modal.close();
      }
    });
  }
  navigateContactUs() {
    this.modal.close();
    this.router.navigate(['/secure/home/contact-us']);
  }

  openLegalAffirmFn() {
    if (this.isGetAgencyFailed) {
      const errorCd = this.agencyListError?.errObject?.metadata?.outcome
        ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          this.agencyListError?.errObject?.metadata?.outcome.code
        : '113480';
      this.appstateFacade.sendAnalytics({
        event: 'error',
        reqData: {
          requirementId: 'acCFBGlobER001',
          userStory: 'MTD-3480',
          hitType: 'error',
        },
        errorData: {
          errorType: 'Compensation_Legal',
          errorCause:
            'We had trouble loading this information.  Please try again later or Contact Us.',
          errorCode: errorCd,
        },
      });
    }
    this.modal.open();
  }

  closeLegalAffirmFn() {
    this.modal.close();
    this.router.navigate(['/secure/commercial/compensation/']);
  }

  goToManageAccess() {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther(
      {},
      'Manage Compensation Access',
      'ac24416',
      {
        eVar119: 'MTD-1385',
        eVar120: 'legal-affirmation-options',
        prop67: 'action',
        channel: 'Compensation',
        pageName: adobeSection.pageName,
        prop20: 'Legal Affirmation modal',
      },
    );
    if (this.router.url === '/secure/commercial/compensation/manage') {
      this.modal.close();
    }
    this.router.navigate(['/secure/commercial/compensation/manage']);
    this.modal.close();
  }

  submitLegalAffirmFn() {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'I Agree', 'ac24416', {
      eVar119: 'MTD-1385',
      eVar120: 'legal-affirmation-options',
      prop67: 'action',
      channel: 'Compensation',
      pageName: adobeSection.pageName,
      prop20: 'Legal Affirmation modal',
    });
    const request: PostAffirmRequestPayload = {
      user_id: '8',
      contact_id: '88',
      affirmation_status: 'Confirmed',
      affirmation_date: moment(new Date()).format('YYYY/MM/DD'),
    };
    this.submitLegalAffirm.emit(request);
  }
}
